import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Visão geral de marketing',
  tiles: {
    followers: 'Seguidores',
    delivered_messages: 'Mensagens entregues',
    open_rate: 'Taxa de abertura',
    click_rate: 'Taxa de clique',
    spam_report_rate: 'Taxa de denúncia de spam',
    unsubscribe_rate: 'Taxa de cancelamento',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: 'Fonte de subscrição',
      count: 'Contagem',
      percentage: 'Percentagem',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Modelo',
      delivered: 'Entregue',
      open_rate: 'Taxa de abertura',
      click_rate: 'Taxa de clique',
      spam_report_rate: 'Taxa de denúncia de spam',
      unsubscribe_rate: 'Taxa de cancelamento',
    },
  },
  labels: {
    no_data: 'Sem dados',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
